import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";

interface ErrorAlertProps {
  error: Error;
  eventId: string | null;
}

export const ErrorAlert = ({ error, eventId }: ErrorAlertProps) => {
  return (
    <div className="flex flex-col bg-white p-5 shadow" role="alert">
      <div className="item-center mb-2.5 flex space-x-3 md:items-start">
        <CancelIcon htmlColor="var(--color-red)" />
        <div className="flex flex-col">
          <p className="body text-md text-red">
            We are having trouble displaying your upcoming orders. Please
            contact our support team to resolve this issue.
          </p>
          <p className="body mt-5 text-md text-red">
            {eventId ? "Error ID: " + eventId : "Error: " + error}
          </p>
        </div>
      </div>
    </div>
  );
};
